export default Object.freeze({
  enUS: 'en-US',
  esES: 'es-ES',
  peES: 'es-PE',
  ptBR: 'pt-BR',
});
